import {Exclude, Expose, Type} from 'class-transformer';

export interface HydraCollectionView {
  '@id'?: string;
  'hydra:next'?: string;
  'hydra:previous'?: string;
}

@Exclude()
export class ResultListApiModel<T> {
  @Expose({ name: 'hydra:member' })
  @Type(options => (options.newObject as ResultListApiModel<T>).type)
  public records: T[] = [];

  @Expose({ name: 'hydra:totalItems' })
  public total: number = 0;

  @Expose({ name: 'hydra:view' })
  public view: HydraCollectionView | null = null;

  @Expose()
  public page: number = 1;

  @Expose()
  public limit: number = 0;

  @Expose()
  public totalPages: number = 1;

  private type: Function;

  constructor(type: Function) {
    this.type = type;
  }

}
